import { type JSX } from 'react'

import { SelectListbox, type SelectListboxProps } from 'base-ui'

import { ProductSearchRefinementDiscountListboxBody } from './ProductSearchRefinementDiscountListboxBody'

export const ProductSearchRefinementDiscountListbox = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>(
  props: SelectListboxProps<OptionValue, Multiple>,
): JSX.Element => (
  <SelectListbox
    {...props}
    slots={{ body: ProductSearchRefinementDiscountListboxBody }}
  />
)
